'use client'

import { Dialog, DialogContent, DialogTitle } from '@elmnts/ui/dialog'
import type { NotificationItem } from '@/services/notifications/types'
import { Notification } from './index'

interface NotificationModalProps {
  notification: NotificationItem | null
  open: boolean
  onOpenChange: (open: boolean) => void
  showReadAction?: boolean
  showDeleteAction?: boolean
  onMarkedRead?: () => void
  onDeleted?: () => void
}

/**
 * Só pra `critical` e `marketing` (Novidade) — bloquear a tela é intencional aí
 * e só aí; a Novidade usa o modal porque o conteúdo dela (passos com vídeo) não
 * cabe em toast.
 * Renderiza o MESMO `Notification.Full` da página de detalhe, só envolto em
 * Dialog: nada de segunda versão do layout pra manter em sincronia.
 */
export function NotificationModal({
  notification,
  open,
  onOpenChange,
  showReadAction = true,
  showDeleteAction = true,
  onMarkedRead,
  onDeleted,
}: NotificationModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* `max-h` + scroll: só rede de segurança em viewport baixa — o stepper da Novidade cabe sem rolar a partir de 1280x720. */}
      <DialogContent className="max-h-[90dvh] overflow-y-auto sm:max-w-2xl">
        {/* Dialog do Radix exige título acessível; o visual vem do Full. */}
        <DialogTitle className="sr-only">{notification?.title ?? 'Notificação'}</DialogTitle>
        {notification && (
          <Notification.Full
            notification={notification}
            showReadAction={showReadAction}
            showDeleteAction={showDeleteAction}
            onMarkedRead={() => {
              onMarkedRead?.()
              onOpenChange(false)
            }}
            onDeleted={() => {
              onDeleted?.()
              onOpenChange(false)
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
